import OSSPreviewImg from "./index.vue";

export default OSSPreviewImg;
